import React, { Component } from 'react'
import { FullScreen } from '../resources/util/FullScreen'
import { Spinner } from '../resources/media/Spinner'
import { LOADING_TITLE } from '../resources/constants/ui'


export default class Loading extends Component {
    render() {
        return (
            <FullScreen centered={true}>
                <h1 className="loading-title">{LOADING_TITLE}</h1><Spinner className="loading__loader"/>
            </FullScreen>
        )
    }
}
